import React, { Component } from "react";
import { Link } from "react-router-dom";
import {
  Image,
  Icon,
  Menu,
  Dropdown,
} from "semantic-ui-react";

import { AppContext } from "../utils/context";
import { baseUrl } from "../utils/constants";
import Clock from "./Clock";

class SidebarNav extends Component {
  constructor(props) {
    super(props);
    this.state = {
      depth: 0,
      isShown: false,
      menusShown: [],
      user: props.user
    };
  }
  render() {
    const { handleSidebar } = this.props;
    const trigger = (
      <Menu.Item fitted>
          <Icon name="user" />
        <AppContext.Consumer>
          {value => <span className="hidden-xs">{value.user.first_name} {value.user.last_name}</span>}
        </AppContext.Consumer>
      </Menu.Item>
    );
    return (
      <Menu inverted fixed="top" color="red" id="mainNav">
        <Menu.Item onClick={handleSidebar}>
          <Icon name="bars" />
        </Menu.Item>
        <Menu.Item fitted>
          <Image src={`${baseUrl}/storage/dashboard/logo.png` }
            onError={(e) => { e.target.src = `${process.env.PUBLIC_URL}/static/images/logo.png` }} style={{ maxHeight: '54px' }} />
        </Menu.Item>
        <Menu.Menu position="right">
          <Menu.Item>
            <Clock />
          </Menu.Item>
          <Menu.Item as={Link} to="/" className="quickLink">
            <Icon name="dashboard" />
          </Menu.Item>
          <Menu.Item as={Link} to="/help" className="quickLink">
            <Icon name="help" />
          </Menu.Item>
          <Dropdown item trigger={trigger}>
            <Dropdown.Menu>
              <Menu.Item onClick={this.props.signOut}>Logout</Menu.Item>
            </Dropdown.Menu>
          </Dropdown>
        </Menu.Menu>
      </Menu>
    );
  }
}

export default SidebarNav;
